(() => {
  if (window.siProductVideoJumpInitialized) return;
  window.siProductVideoJumpInitialized = true;

  function hasVideo(section) {
    if (!section.id || !section.getClientRects().length) return false;
    const player = section.querySelector('video-component');
    const mediaSelector = 'video[src], video source[src], iframe[src]';
    return Boolean(
      player?.querySelector(mediaSelector) ||
      player?.querySelector('template')?.content.querySelector(mediaSelector)
    );
  }

  function connectLinks() {
    const videos = [...document.querySelectorAll('[data-section-type="video-section"]')].filter(hasVideo);

    const guide = document.querySelector('[data-si-buying-guide-target]');
    const reviews = document.getElementById('judgeme_product_reviews');
    for (const link of document.querySelectorAll('[data-si-reviews-jump], [data-si-guide-jump]')) {
      const target = link.hasAttribute('data-si-guide-jump') ? guide : reviews;
      const visible = Boolean(target?.id && target.getClientRects().length);
      link.hidden = !visible;
      if (visible) {
        target.classList.add('si-product-video-target');
        target.setAttribute('tabindex', '-1');
        link.href = '#' + target.id;
      } else {
        link.removeAttribute('href');
      }
    }

    for (const link of document.querySelectorAll('[data-si-video-jump]')) {
      const targetId = link.dataset.targetId;
      const target = videos.find((video) => {
        const followsLink = link.compareDocumentPosition(video) & Node.DOCUMENT_POSITION_FOLLOWING;
        return followsLink && (!targetId || video.id === targetId);
      });

      link.hidden = !target;
      if (!target) {
        link.removeAttribute('href');
        continue;
      }

      target.classList.add('si-product-video-target');
      target.setAttribute('tabindex', '-1');
      link.href = '#' + target.id;
    }
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-si-video-jump][href], [data-si-reviews-jump][href], [data-si-guide-jump][href]');
    if (!link || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    target?.focus({ preventScroll: true });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connectLinks, { once: true });
  } else {
    connectLinks();
  }
  for (const event of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) {
    document.addEventListener(event, () => requestAnimationFrame(connectLinks));
  }
})();
